// src/components/store/sections/newsletter/NewsletterV61MinimalinlineLimeZest.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV61MinimalinlineLimeZest(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={61}
      archKey="minimal_inline"
      archLabel="Minimalist Inline Strip"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#84cc16"
      {...props}
    />
  );
}
